//styles broken atm

//@flow
import React, { Component } from 'react';
import {
  PasswordValidationWrapper,
  PasswordBackground,
  PasswordText
} from './PasswordValidationStyles';

type Props = {
  touched: boolean,
  warning: ?string,
  error: ?string
};

export default class PasswordValidation extends Component<Props> {
  render() {
    let text = 'Password empty';
    if (this.props.touched && this.props.error) {
      text = this.props.error;
    } else if (this.props.touched && this.props.warning) {
      text = this.props.warning;
    } else if (this.props.touched) {
      text = 'Strong password';
    }

    return (
      <PasswordValidationWrapper>
        <PasswordBackground color={this.props.touched ? 'red' : 'concrete'} />
        <PasswordBackground color={this.props.error ? 'concrete' : 'yellow'} />
        <PasswordBackground
          color={this.props.warning ? 'concrete' : 'graphicGreen'}
        />
        <PasswordText>{text}</PasswordText>
      </PasswordValidationWrapper>
    );
  }
}
